<div app-sortable id="indicatorsID" class="p-1 isSortableContainer app-sortable-container" (sendSortableStop)="receiveSortableStop($event)">
  <app-widget-indicators-item *ngFor="let indicator of widgetLayers.indicators ; let i = index ; let isLast = last" class="isSortableElement app-cursor-grab"
    [indicator]="indicator" 
    [index]="i" 
    [selected]="selected == i" 
    (sendEdited)="receiveEdited($event)"
    [isLast]="isLast"
  ></app-widget-indicators-item>
</div>